import React, { useContext } from 'react'
import { getAllTimesheets } from './api';
import { useQuery } from '@tanstack/react-query';
import { AuthContext } from '../../../context/authContext';
import { timesheetColumns } from './columns';
import { Box, Button, Typography } from '@mui/material';
import { MaterialReactTable } from 'material-react-table';
import { tableDesignProps } from '../../../styles/muiProps';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { mkConfig, generateCsv, download } from 'export-to-csv';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { sanitizeForCsv } from '../../../components/Tables/utils';

const csvConfig = mkConfig({
    fieldSeparator: ',',
    decimalSeparator: '.',
    useKeysAsHeaders: true,
});

const AllTimesheetsPage = () => {
    const { accessToken, role } = useContext(AuthContext);

    const { isSuccess, isLoading, isError, data: allTimesheets } = useQuery({
        queryKey: ['timesheets_all'],
        queryFn: () => getAllTimesheets({ accessToken }),
    })
    if (isSuccess) {
        console.log({ allTimesheets })
    }

    const colsToExport = ['date', 'task.task', 'hours'];

    const getNestedValue = (obj, path) => {
        return path.split('.').reduce((acc, part) => acc?.[part], obj);
    };

    // export rows to csv
    const handleExportRows = (rows) => {
        const grouped = {};

        console.log("ROWS", rows)

        rows.forEach(({ original }) => {
            const taskName = getNestedValue(original, 'task.task');
            console.log("TAskaname", taskName)
            if (!grouped[taskName]) {
                grouped[taskName] = { ...original };
            } else {
                grouped[taskName].hours += original.hours || 0;
            }
        });

        // Turn grouped object into array
        const consolidatedRows = Object.values(grouped);

        const rowData = consolidatedRows.map((row) => sanitizeForCsv(row, colsToExport));
        const csv = generateCsv(csvConfig)(rowData);
        download(csvConfig)(csv);
    };


    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Box sx={{ "display": "flex", alignItems: "start" }}>
                <Box sx={{ m: 4, width: "100%", pr: 3 }}>
                    <Typography variant="h4" color="secondary" pb={2}>All Timesheets</Typography>
                    <MaterialReactTable
                        columns={timesheetColumns}
                        enableGrouping
                        enableColumnDragging={false}
                        enableRowSelection
                        defaultColumn={{
                            minSize: 20, //allow columns to get smaller than default
                            // maxSize: 9001, //allow columns to get larger than default
                            // size: 260, //make columns wider by default
                        }}
                        renderTopToolbarCustomActions={({ table }) => (
                            <div>
                                <Button
                                    disabled={
                                        !table.getIsSomeRowsSelected() && !table.getIsAllRowsSelected() && role && role === "admin"
                                    }
                                    //only export selected rows
                                    onClick={() => handleExportRows(table.getSelectedRowModel().rows)}
                                    startIcon={<FileDownloadIcon />}
                                >
                                    Export Selected Rows
                                </Button>
                            </div>
                        )}
                        data={allTimesheets || []}
                        {...tableDesignProps}
                        columnFilterDisplayMode={'popover'}
                        initialState={{
                            columnVisibility: { id: false },
                            sorting: [{ id: "date", desc: true }],
                            grouping: ['task.project.projectName'],
                        }}
                    />
                </Box>
            </Box>
        </LocalizationProvider>
    )
}

export default AllTimesheetsPage